import Congrats from './Congrats';

export default Congrats;
